import { useTranslation } from "react-i18next";
import { MegamenuItem, NavItemType } from "shared/Navigation/NavigationItem";
import ncNanoId from "utils/ncNanoId";
export const NAVIGATION_DEF: NavItemType[] = [
  {
    id: ncNanoId(),
    href: "/",
    name: "Home"
  },
  {
    id: ncNanoId(),
    href: "/join",
    name: "join_partner"
  },
];

export const NAVIGATION_DEF_GUIDE: NavItemType[] = [
  {
    id: ncNanoId(),
    href: "/",
    name: "Home"
  },
  {
    id: ncNanoId(),
    href: "/manage-products",
    name: "Manajemen Produk"
  },
];

const listingMenu: MegamenuItem[] = [
  {
    id: ncNanoId(),
    image:
      "https://guidesantai.com/images/open_trip.jpg",
    title: "Open Trip",
    items: [
      {
        id: ncNanoId(),
        href: "open-trip-add",
        name: "add_new",
      }
    ],
  },
  {
    id: ncNanoId(),
    image:
      "https://guidesantai.com/images/private_trip.jpeg",
    title: "Private Trip",
    items: [
      {
        id: ncNanoId(),
        href: "private-trip-add",
        name: "add_new",
      }
    ],
  }
];

export const GUIDE_NAVIGATION: NavItemType[] = [
  {
    id: ncNanoId(),
    href: "/",
    name: "Home"
  },
  {
    id: ncNanoId(),
    href: "/manage-products",
    name: "Manajemen Produk"
  },
];


